import { ButtonVariant } from "components/CoButton";
import CardTooltip from "components/Popover/CardTooltip";
import { CONSENSUS_METER_URL } from "constants/config";
import useLabels from "hooks/useLabels";

export const HeaderTagTooltip = () => {
  const [title, tooltipLabels] = useLabels(
    "consensus-meter.title",
    "consensus-meter.beta-tooltip"
  );

  return (
    <CardTooltip>
      <CardTooltip.Header title={title} />
      <CardTooltip.Description content={tooltipLabels["description"]} />
      <CardTooltip.InfoSection infoText={tooltipLabels["info"]} />
      <CardTooltip.Button
        label={tooltipLabels["cta"]}
        href={CONSENSUS_METER_URL}
        target="_blank"
        iconRight="icon-external-link"
        variant={ButtonVariant.Tertiary}
      />
    </CardTooltip>
  );
};
